import { FieldRenderProps, FieldWrapper } from "@progress/kendo-react-form";
import { TextBox } from "@progress/kendo-react-inputs";
import { Label, Error, Hint } from "@progress/kendo-react-labels";

export default function FormTextBox(fieldRenderProps: FieldRenderProps) {
    const {
        validationMessage,
        touched,
        label,
        id,
        maxLenght,
        valid,
        disabled,
        hint,
        type,
        optional,
        wrapperStyle,
        title,
        onClick,
        ...others
    } = fieldRenderProps;

    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint;
    const hintId = showHint ? `${id}_hint` : '';
    const errorId = showValidationMessage ? `${id}_error` : '';

    return (
        <FieldWrapper style={wrapperStyle}>
            {label && <Label
                editorId={id}
                editorValid={valid}
                editorDisabled={disabled}
                optional={optional}
            >
                {label}
            </Label>}
            <div className={'k-form-field-wrap'} onClick={onClick}>
                <TextBox
                    valid={valid}
                    type={type}
                    id={id}
                    maxLength={maxLenght}
                    className='customInput textbox'
                    disabled={disabled}
                    aria-describedby={`${hintId} ${errorId}`}
                    title={title}
                    {...others}
                />
                {showHint && <Hint id={hintId}>{hint}</Hint>}
                {showValidationMessage && (
                    <Error id={errorId}>{validationMessage}</Error>
                )}
            </div>
        </FieldWrapper>
    );
};